/**
 * 书籍篇幅 / 价格档闭集（ADM-BOK-S019）与买断产品映射行（ADM-APP-S015）。
 *
 * 对照表只用于建书写入 length_class 时初始化 price_level 一次；此后两列解耦。
 */
import { z } from 'zod';

export const NOVEL_LENGTH_CLASSES = ['SHORT', 'MEDIUM', 'MEDIUM_LONG', 'LONG', 'EPIC'] as const;
export type NovelLengthClass = (typeof NOVEL_LENGTH_CLASSES)[number];

export const NOVEL_PRICE_LEVELS = ['L1', 'L2', 'L3', 'L4', 'L5'] as const;
export type NovelPriceLevel = (typeof NOVEL_PRICE_LEVELS)[number];

/** 建书时 length_class → price_level 一次性初始化（A6 §16.1）。 */
export const PRICE_LEVEL_FROM_LENGTH_CLASS = {
  SHORT: 'L1',
  MEDIUM: 'L2',
  MEDIUM_LONG: 'L3',
  LONG: 'L4',
  EPIC: 'L5',
} as const satisfies Record<NovelLengthClass, NovelPriceLevel>;

export const NovelLengthClassSchema = z.enum(NOVEL_LENGTH_CLASSES);
export const NovelPriceLevelSchema = z.enum(NOVEL_PRICE_LEVELS);

export const NovelPurchaseProductMappingSchema = z
  .object({
    price_level: NovelPriceLevelSchema,
    access_level_id: z.string().trim().min(1).max(255),
  })
  .strict();
export type NovelPurchaseProductMapping = z.infer<typeof NovelPurchaseProductMappingSchema>;

export function initialPriceLevelForLengthClass(lengthClass: NovelLengthClass): NovelPriceLevel {
  return PRICE_LEVEL_FROM_LENGTH_CLASS[lengthClass];
}
